import type React from 'react'

type Props = {
  color?: string
  size?: number
}

const IconInputCheck: React.FC<Props> = ({ color = '#768BA7', size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.3281 3.89307C14.6211 4.18604 14.6211 4.62549 14.3281 4.88916L6.59375 12.6235C6.33008 12.9165 5.89062 12.9165 5.62695 12.6235L1.64258 8.63916C1.34961 8.37549 1.34961 7.93604 1.64258 7.64307C1.90625 7.37939 2.3457 7.37939 2.60938 7.64307L6.125 11.1587L13.3613 3.89307C13.625 3.62939 14.0645 3.62939 14.3281 3.89307Z"
      fill={color}
    />
  </svg>
)

export default IconInputCheck
